import * as uwApi from "./uwApi";

export type WorkbenchApi = typeof uwApi;

/**
 * Screens and stores call getApi() rather than importing uwApi directly. There is one implementation in the app; the
 * indirection exists so the test suite can stand in a fake (src/test/fakeApi, wired through vi.mock in the test setup)
 * without every screen knowing about it. The mock-data mode the mockup phase shipped with (USE_MOCKS) is gone.
 */
export function getApi(): WorkbenchApi {
  return uwApi;
}
